import { render, staticRenderFns } from "./PopUpLogo.vue?vue&type=template&id=cd766dfe&scoped=true"
import script from "./PopUpLogo.vue?vue&type=script&lang=js"
export * from "./PopUpLogo.vue?vue&type=script&lang=js"
import style0 from "./PopUpLogo.vue?vue&type=style&index=0&id=cd766dfe&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd766dfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd766dfe')) {
      api.createRecord('cd766dfe', component.options)
    } else {
      api.reload('cd766dfe', component.options)
    }
    module.hot.accept("./PopUpLogo.vue?vue&type=template&id=cd766dfe&scoped=true", function () {
      api.rerender('cd766dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Account/PopUps/PopUpLogo.vue"
export default component.exports